import { ShotOffTargetAttribute } from '@collector/sportsapi-client-legacy'

import { DetailBaseConfigAttributes } from '../../../../composables/useSportOptions'

export const techniqueOfShotDetailsAttributes: DetailBaseConfigAttributes<ShotOffTargetAttribute>['attributes'] =
  [
    {
      attributeId: ShotOffTargetAttribute.LeftFoot,
      isActive: (attributes) => {
        const validAttributes = [
          ShotOffTargetAttribute.Normal,
          ShotOffTargetAttribute.FirstTouch,
          ShotOffTargetAttribute.Volley,
          ShotOffTargetAttribute.DirectFreeKick,
          ShotOffTargetAttribute.BicycleKick,
        ]

        return attributes.some((attribute) =>
          validAttributes.includes(attribute),
        )
      },
    },
    {
      attributeId: ShotOffTargetAttribute.Chip,
      isActive: (attributes) => {
        const validAttributes = [
          ShotOffTargetAttribute.Normal,
          ShotOffTargetAttribute.FirstTouch,
        ]

        return attributes.some((attribute) =>
          validAttributes.includes(attribute),
        )
      },
    },
    {
      attributeId: ShotOffTargetAttribute.RightFoot,
      isActive: (attributes) => {
        const validAttributes = [
          ShotOffTargetAttribute.Normal,
          ShotOffTargetAttribute.FirstTouch,
          ShotOffTargetAttribute.Volley,
          ShotOffTargetAttribute.DirectFreeKick,
          ShotOffTargetAttribute.BicycleKick,
        ]

        return attributes.some((attribute) =>
          validAttributes.includes(attribute),
        )
      },
    },
  ]
